/**
 * The centre of a pipeline page: the viewer once there is something to view,
 * and the way in before that.
 *
 * `ViewportGrid` on its own renders "No case open — open or create a case from
 * the Home tab", which spends the largest region of the window telling the
 * reader to leave. Wrapping it means the DWI page can start DWI work, which is
 * the only reason to have a DWI page.
 */

import type { PipelineKind } from "@/ipc/contract";
import { useAppStore } from "@/store/appStore";
import { CaseSharedViewer } from "@/viewer/CaseSharedViewer";
import { StudyStart } from "./StudyStart";

function centreFor(kind: PipelineKind) {
  return function PipelineCentre() {
    const hasCase = useAppStore((s) => s.currentCase != null);
    return hasCase ? <CaseSharedViewer /> : <StudyStart kind={kind} />;
  };
}

export const DwiCentre = centreFor("dwi");
export const PwiCentre = centreFor("pwi");
